import { LoadableAfterPaint } from '@confluence/loadable';
import type { SatisfactionSurveyFlagProps } from '../src/SatisfactionSurveyFlag';

export const SatisfactionSurveyFlag = LoadableAfterPaint<SatisfactionSurveyFlagProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SatisfactionSurveyFlag" */ '../src/SatisfactionSurveyFlag'
			)
		).SatisfactionSurveyFlag,
});
